import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { SharedModule } from '@shared/shared.module';

import { CreditModule } from '@credit/credit.module';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { FormlyMatNativeSelectModule } from '@ngx-formly/material/native-select';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { NgxCurrencyModule } from 'ngx-currency';
import { ChangePasswordInstructionViewComponent } from './change-password/change-password-instruction-view/change-password-instruction-view.component';
import { IdentityValidationComponent } from '../home/identity-validation/identity-validation.component';
import { ChangePasswordInstructionComponent } from './change-password/change-password-instruction/change-password-instruction.component';
import { LinkExpiredViewComponent } from './change-password/link-expired-view/link-expired-view.component';
import { LinkExpiredComponent } from './change-password/link-expired/link-expired.component';
import { RecoverPasswordViewComponent } from './change-password/recover-password-view/recover-password-view.component';
import { RecoverPasswordComponent } from './change-password/recover-password/recover-password.component';
import { RestorePasswordViewComponent } from './change-password/restore-password-view/restore-password-view.component';
import { RestorePasswordComponent } from './change-password/restore-password/restore-password.component';
import { FormsComponent } from './forms/forms.component';
import { HeadUnauthComponent } from './head-unauth/head-unauth.component';
import { HeaderComponent } from './header/header.component';
import { LockCardDialogComponent } from './header/components/lock-card-dialog/lock-card-dialog.component';
import { OtpDialogComponent } from './header/components/otp-dialog/otp-dialog.component';
import { HomeRoutingModule } from './home-rounting.module';
import { LoginComponent } from './login/login.component';
import { ATMComponent } from './pay/modals/atm/atm.component';
import { BankCorrespondentComponent } from './pay/modals/bank-correspondent/bank-correspondent.component';
import { BankDepositComponent } from './pay/modals/bank-deposit/bank-deposit.component';
import { BankTransferComponent } from './pay/modals/bank-transfer/bank-transfer.component';
import { EfectyBalotoComponent } from './pay/modals/efecty-baloto/efecty-baloto.component';
import { SusuerteComponent } from './pay/modals/susuerte/susuerte.component';
import { PaymentReferenceComponent } from './pay/payment-reference/payment-reference.component';
import { ActiveCreditsListComponent } from '@credit/active-credits-list';
import { PaymentMethodsComponent } from './payment-methods';
import { RenegotiateLoanComponent } from '@credit/renegotiate-loan';
import { RapicreditSkeletonModule } from '@core/components/rapicredit-skeleton/rapicredit-skeleton.module';
import { ReferralsComponent } from './referrals';
import { UnifiedHomeComponent } from './unified-home/unified-home.component';
import { PaymentStatusComponent } from './payment-status';

@NgModule({
  declarations: [
    LoginComponent,
    PaymentReferenceComponent,
    PaymentMethodsComponent,
    ReferralsComponent,
    HeaderComponent,
    LockCardDialogComponent,
    OtpDialogComponent,
    FormsComponent,
    EfectyBalotoComponent,
    BankTransferComponent,
    BankDepositComponent,
    ATMComponent,
    BankCorrespondentComponent,
    HeadUnauthComponent,
    RecoverPasswordViewComponent,
    RecoverPasswordComponent,
    RestorePasswordViewComponent,
    RestorePasswordComponent,
    ChangePasswordInstructionViewComponent,
    ChangePasswordInstructionComponent,
    LinkExpiredViewComponent,
    LinkExpiredComponent,
    IdentityValidationComponent,
    SusuerteComponent,
    ActiveCreditsListComponent,
    PaymentMethodsComponent,
    RenegotiateLoanComponent,
    UnifiedHomeComponent,
    PaymentStatusComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    CreditModule,
    HomeRoutingModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    FormlyMatNativeSelectModule,
    FormlyMaterialModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    FormlyModule,
    MatMenuModule,
    MatSidenavModule,
    MatToolbarModule,
    MatExpansionModule,
    MatListModule,
    MatRadioModule,
    NgxCurrencyModule,
    MatButtonModule,
    FlexLayoutModule,
    MatCheckboxModule,
    MatDialogModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    RapicreditSkeletonModule,
  ],
  exports: [HeaderComponent],
  providers: [ReCaptchaV3Service],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HomeModule {}
